import { type FC, type ReactNode } from 'react'

interface SchedulingStatusCardProps {
  icon: ReactNode
  title: string
  subtitle: string
  children?: ReactNode
}

export const SchedulingStatusCard: FC<SchedulingStatusCardProps> = ({ icon, title, subtitle, children }) => (
  <div className='border rounded-3 d-flex flex-column align-items-center text-center zocks-py-4.0 px-4'>
    <div className='fs-2 lh-1 mb-3'>{icon}</div>
    <div className='h5 mb-1'>{title}</div>
    <div className='paragraph-small zocks-text-gray-600'>{subtitle}</div>
    {children ? <div className='d-flex align-items-center justify-content-center gap-2 mt-4'>{children}</div> : null}
  </div>
)
